import { useMantineTheme } from "@mantine/core";
import { Fragment } from "react";
import { colors } from "theme";

import { useStyles } from "components/VehicleImpact/styles";

import { useClientTranslation } from "hooks/useClientTranslation";

import { CORNER_POSITIONS, POINT_OF_IMPACT_TRANSLATION_KEYS } from "./constants";
import { PointOfImpact } from "./types";
import { useDJPointOfImpactList } from "./useDJPointOfImpactList";

export const DJImpactSelectors = ({ editable = true, showRoofPOI = false }) => {
  const { classes } = useStyles({ editable });
  const { orderedList, setOrderedList } = useDJPointOfImpactList();
  const theme = useMantineTheme();
  const { t } = useClientTranslation();

  const roofKey = "Roof";
  const isRoofSelected = orderedList.includes(roofKey);
  const fillColourRoof = isRoofSelected ? theme.other.primary[60] : colors.grey[30];

  return (
    <>
      {Object.entries(CORNER_POSITIONS).map(([point, position]) => {
        const pointOfImpact = point as PointOfImpact;
        const selected = orderedList.includes(pointOfImpact);
        const fillColour = selected ? theme.other.primary[60] : colors.grey[30];
        const concatenatedPOI = pointOfImpact.replace(/\s/g, "");
        return (
          <Fragment key={concatenatedPOI}>
            <label
              htmlFor={`${concatenatedPOI}-option`}
              id={`${concatenatedPOI}-label`}
              className={classes.showOnlyToScreenReaders}
            >
              {t(POINT_OF_IMPACT_TRANSLATION_KEYS[pointOfImpact])}
            </label>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              role="checkbox"
              aria-checked={selected}
              onClick={() => editable && setOrderedList(pointOfImpact, !selected)}
              aria-labelledby={`${concatenatedPOI}-label`}
              xmlns="http://www.w3.org/2000/svg"
              className={classes.impactSelector}
              style={position}
            >
              <path
                d="M4.30012 9.65719L6.63783 12L4.30013 14.3428L5.01981 15.0625L8.08231 12L5.01981 8.9375L4.30012 9.65719Z"
                fill={fillColour}
              />
              <path
                d="M8.34456 8.98781L11.3502 12L8.34456 15.0122L9.26987 15.9375L13.2074 12L9.26987 8.0625L8.34456 8.98781Z"
                fill={fillColour}
              />
              <path
                d="M12.8487 7.98375L16.8562 12L12.8487 16.0163L14.0825 17.25L19.3325 12L14.0825 6.75L12.8487 7.98375Z"
                fill={fillColour}
              />
            </svg>
          </Fragment>
        );
      })}
      {showRoofPOI && (
        <Fragment key={roofKey}>
          <label htmlFor={`${roofKey}-option`} id={`${roofKey}-label`} className={classes.showOnlyToScreenReaders}>
            test
          </label>
          <svg
            width="15"
            height="14"
            viewBox="0 0 15 14"
            fill="none"
            role="checkbox"
            aria-checked={isRoofSelected}
            onClick={() => editable && setOrderedList(roofKey, !isRoofSelected)}
            aria-labelledby={`${roofKey}-label`}
            xmlns="http://www.w3.org/2000/svg"
            className={classes.impactSelector}
            style={{
              left: "50%",
              top: "55%",
              transform: "translate(-50%, -50%)",
              width: "16",
              zIndex: 1,
            }}
          >
            <path
              d="M12.7699 13.5898L7.4518 8.28076L2.13367 13.5898L0.5 11.9554L7.4518 5.00026L14.4036 11.9554L12.7699 13.5898Z"
              fill={fillColourRoof}
            />
            <path
              d="M2.13437 -1.07267e-06L7.4525 5.30908L12.7706 -1.4282e-07L14.4043 1.63445L7.45249 8.58958L0.500694 1.63445L2.13437 -1.07267e-06Z"
              fill={fillColourRoof}
            />
          </svg>
        </Fragment>
      )}
    </>
  );
};
